import styled from "styled-components";
import { Box, colors, darken, lighten } from "@mui/material";
import { TemplateColorObject } from "../../../../../InvitationColorMatrix";

export const CommentsWrapper = styled(Box)<{ colormatrix: TemplateColorObject }>`
	width: 100%;
	.myComment {
		background: ${props => props.colormatrix.main};
		color: ${props => props.colormatrix.font.tertiary};
		box-shadow: 0 0 2px 1px #8b8b8b;
		border-radius: 5px;
		padding: 10px;
		box-sizing: border-box;
		.delete_icon {
			background: ${props => darken(props.colormatrix.main, 0.1)};
			color: ${props => props.colormatrix.font.tertiary};
		}
		.accept_icon {
			color: ${colors.green[400]};
			width: 18px;
		}
		.reject_icon {
			color: ${colors.red[400]};
			width: 18px;
		}
	}
	.comments_wrapper {
		display: flex;
		flex-direction: column;
		margin: 50px 20px;
		grid-gap: 15px;

		.comment {
			display: flex;
			flex-direction: column;
			grid-gap: 5px;
			color: ${props => props.colormatrix.font.secondary};
			.name_wrapper {
				display: flex;
				grid-gap: 10px;
				align-items: center;
				p::first-letter {
					text-transform: capitalize;
				}
				p:first-child {
					color: ${props => props.colormatrix.font.primary};
					font-family: var(--roboto), sans-serif;
					font-size: 14px;
					font-weight: 500;
				}
				p:last-child {
					font-family: var(--openSans), sans-serif;
					font-size: 12px;
					color: ${props => lighten(props.colormatrix.font.primary, 0.2)};
				}
			}
			.accept_icon {
				color: ${colors.green[400]};
				width: 18px;
			}
			.reject_icon {
				color: ${colors.red[400]};
				width: 18px;
			}
		}
	}
`;
